// src/components/private/highgarden/Grocery.js
// Parent component for both GroceryListManager and GroceryListDetails

import React, { useState } from 'react';
import GroceryLists from './GroceryLists';
import GroceryListDetails from './GroceryListDetails';
import { Container, Row, Col } from 'react-bootstrap';

const Grocery = () => {
    const [selectedList, setSelectedList] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0); // Used to trigger a re-render
    const [showListColumn, setShowListColumn] = useState(true);

    const refreshLists = () => {
        setRefreshKey(oldKey => oldKey + 1); // Increment the key to trigger a re-render
        setSelectedList(null); // Reset selected list
        setShowListColumn(true); // Show the list column again when refreshing
    };

    const handleSelectList = (list) => {
        setSelectedList(list);
    };

    const handleSingleList = (list) => {
        setSelectedList(list);
        setShowListColumn(false);
    };

    return (
        <Container fluid className="mt-0 p-0" style={{ height: '100vh', width: '100%' }}>
            <Row>
                {showListColumn && (
                    <Col xs={4} md={3} >
                        <GroceryLists key={refreshKey} onSelectList={handleSelectList} onSingleList={handleSingleList} />
                    </Col>
                )}
                <Col xs={showListColumn ? 8 : 12} md={showListColumn ? 9 : 12}>
                    {selectedList ? (
                        <GroceryListDetails refreshLists={refreshLists} list={selectedList} />
                    ) : (
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            Select a list to see items, or create a new one.
                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default Grocery;